import { useLogoutEverywhere } from "@coaching-culture/api-client";
import {
  Alert,
  Box,
  Button,
  ConfirmationModal,
  Panel,
  Text,
} from "@coaching-culture/ui";
import { useUser } from "auth";
import React, { useState } from "react";
import { useHistory } from "react-router";

/** "Log out everywhere": ends this account's sessions on every device. */
export const SessionSettings = () => {
  const [user, setToken] = useUser();
  const history = useHistory();
  const [confirming, setConfirming] = useState(false);
  const [failed, setFailed] = useState(false);
  const logoutEverywhere = useLogoutEverywhere();

  // While impersonating, the API would end the partner user's own sessions.
  if (user.impersonator != null) {
    return null;
  }

  const confirm = () => {
    setConfirming(false);
    setFailed(false);
    logoutEverywhere
      .mutateAsync()
      .then(() => {
        setToken(null);
        history.push("/login");
      })
      .catch(() => setFailed(true));
  };

  return (
    <Panel p={[3, 5]} mt={3}>
      <ConfirmationModal
        isOpen={confirming}
        onCancel={() => setConfirming(false)}
        title="Log out everywhere?"
        modalText="You'll be signed out on every device and browser, including this one."
        cancelText="Cancel"
        buttons={[
          { text: "Log out everywhere", color: "danger", onClick: confirm },
        ]}
      />
      <Text as="h2" m={0} mb={1} fontSize="title" fontWeight={600}>
        Sessions
      </Text>
      <Text as="p" color="textMuted" mb={3}>
        Signed in on a shared or lost device? Log out everywhere to end every
        session on this account. You'll need to sign in again here too.
      </Text>
      {failed && (
        <Alert color="danger" mb={3}>
          Something went wrong. Please try again.
        </Alert>
      )}
      <Box>
        <Button
          onClick={() => setConfirming(true)}
          disabled={logoutEverywhere.isLoading}
        >
          Log out everywhere
        </Button>
      </Box>
    </Panel>
  );
};
